import * as React from 'react';
import { createService } from '../createService';
import { TopIcon } from '../icons';

export const TopService = createService({
  title: 'Топ',
  subTitle: 'Максимум звонков',
  description: ['Выше конкурентов', 'Большая карточка и 4 фото', 'Эффективное продвижение'],
  dataName: 'TopService',
  bgColor: 'gradient',
  icon: <TopIcon />,
});
